export default __webpack_public_path__ + "PieChart.png";